import React from "react";

/**
 * A titled band plus the rows that belong to it.
 */
const AccountSettingsSection = ({ title, children }) => {
  return (
    <React.Fragment>
      <div className="bwai-as-band">{title}</div>
      <div className="bwai-as-section">{children}</div>
    </React.Fragment>
  );
};

export default AccountSettingsSection;
